// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28JHW","label":"styles_label__3KJp7"};